import React from 'react';
import { NamespaceConsumer } from '@ux/namespace-component';

/**
 * Representation of a Header in the Dialog.
 *
 * @constructor
 * @public
 */
export default class Header extends NamespaceConsumer {
  render() {
    const { children, onClick } = this.props;
    const close = typeof onClick === 'function' && (
      <button tabIndex='0'
        type='button'
        data-action='close'
        className={ this.namespace('close') }
        data-dismiss='modal'
        aria-label='Close'
        onClick={ onClick }>

        <span aria-hidden='true'>×</span>
      </button>
    );

    return (
      <div className={ this.namespace('modal-header') }>
        { close }
        <h2 className={ this.namespace('modal-title') }>{ children }</h2>
      </div>
    );
  }
}
